'use strict';

const bindingsConfig = $compileProvider => {
	$compileProvider.preAssignBindingsEnabled(true);
};

module.exports = {
	bindingsConfig
};
